export default {
  // Navigation
  'nav.home': '首页',
  'nav.product': '产品介绍',
  'nav.cases': '成功案例',
  'nav.findDoctor': '家长指引',
  'nav.about': '关于我们',
  'nav.doctorLogin': '医生登录',
  
  // Common
  'common.learnMore': '了解更多',
  'common.contactUs': '联系我们',
  'common.submit': '提交',
  'common.search': '搜索',
  
  // Footer
  'footer.quickLinks': '快速链接',
  'footer.contact': '联系我们',
  'footer.followUs': '关注我们',
  'footer.copyright': '© 2024 Mirókids. 版权所有.',
  'footer.phone': '电话',
  'footer.email': '邮箱',
  'footer.address': '地址',
};
